import React from 'react';
import Layout from '@/pages/_layout';
import PageWrapper from '@/components/PageWrapper';
export default () => (<Layout>
    <PageWrapper>
      404
    </PageWrapper>
  </Layout>);
